import axios from "axios";
import { HOST_URL } from "@/api/config";
import { authEntity } from "@/models/modules/auth/entity";
import { langEntity } from "@/models/modules/lang/entity";
import { IAxiosCustomRequestConfig } from "@/api/interface";
import { profileEntity } from "@/models/modules/profile/entity";
import { version } from '../../package.json';

axios.defaults.baseURL = HOST_URL;

axios.defaults.paramsSerializer = (params: any): string => {
	let v: string = '';

	for (let [ key, val ] of Object.entries(params)) {
		if (val === undefined) continue;

		v += '&' + (Array.isArray(val) ? val.map(i => i === undefined ? '' : `${key}=${i}`).filter(i => !!i).join('&') : `${key}=${val}`);
	}

	return v.slice(1) || '';
};

axios.interceptors.request.use((config : IAxiosCustomRequestConfig) => {
	if (!config.headers['Content-Type'])
		config.headers['Content-Type'] = 'application/json';

	if (profileEntity.profileData?.flCrmId)
		config.headers['customerId'] = String(profileEntity.profileData.flCrmId);

	config.headers['lang'] = langEntity.lang;
	config.headers.Release = version.split('-').shift();

	if (authEntity.accessToken) {
		config.headers['Authorization'] = 'Bearer ' + authEntity.accessToken;
	}

	if (config.API_HANDLER_CONFIG?.useRefreshToken === true) {
		config.headers['Authorization'] = 'Bearer ' + authEntity.refreshToken;
	}

	if (config.API_HANDLER_CONFIG?.dontAuth === true) {
		delete config.headers['Authorization'];
	}

	// Without this axios will not send headers
	if (!config.data) config.data = null;

	return config;
});